var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3229",
    "data-name": "Rectangle 3229",
    width: 106,
    height: 106,
    transform: "translate(0 -0.135)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10928",
    "data-name": "Group 10928",
    transform: "translate(-0.034 0.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10927",
    "data-name": "Group 10927",
    transform: "translate(0.034)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29433",
    "data-name": "Path 29433",
    d: "M91.241,46.558A44.683,44.683,0,1,1,46.558,1.875,44.671,44.671,0,0,1,91.241,46.558",
    transform: "translate(6.349 6.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29434",
    "data-name": "Path 29434",
    d: "M20.8,15.84a4.965,4.965,0,1,1-4.965-4.965A4.967,4.967,0,0,1,20.8,15.84",
    transform: "translate(37.067 37.118)",
    fill: "#e5303e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29435",
    "data-name": "Path 29435",
    d: "M51.678.375a51.3,51.3,0,1,0,51.3,51.3,51.293,51.293,0,0,0-51.3-51.3m0,92.676A41.373,41.373,0,1,1,93.051,51.678,41.383,41.383,0,0,1,51.678,93.051",
    transform: "translate(1.229 1.28)",
    fill: "#e5303e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29436",
    "data-name": "Path 29436",
    d: "M71.162,51.3H57.614a5,5,0,0,0-3-3V28.134a1.655,1.655,0,1,0-3.31,0V48.3a4.949,4.949,0,1,0,6.311,6.311H71.162a1.655,1.655,0,1,0,0-3.31m-18.2,3.31a1.655,1.655,0,1,1,1.655-1.655,1.656,1.656,0,0,1-1.655,1.655M83.453,22.635c-.035-.035-.035-.071-.066-.106s-.071-.031-.106-.066a42.961,42.961,0,0,0-60.645,0c-.035.035-.071.035-.106.066s-.031.071-.066.106a42.961,42.961,0,0,0,0,60.645c.035.035.035.071.066.106s.071.031.106.066a42.961,42.961,0,0,0,60.645,0c.035-.035.071-.035.106-.066s.031-.071.066-.106a42.961,42.961,0,0,0,0-60.645M82.142,79.8,78.7,76.37A1.645,1.645,0,0,0,76.37,78.7L79.8,82.142A39.408,39.408,0,0,1,54.613,92.588V87.711a1.655,1.655,0,1,0-3.31,0v4.877A39.408,39.408,0,0,1,26.117,82.142L29.546,78.7A1.645,1.645,0,0,0,27.22,76.37L23.774,79.8A39.408,39.408,0,0,1,13.328,54.613H18.2a1.655,1.655,0,1,0,0-3.31H13.328A39.408,39.408,0,0,1,23.774,26.117l3.447,3.429a1.645,1.645,0,0,0,2.326-2.326l-3.429-3.447A39.408,39.408,0,0,1,51.3,13.328V18.2a1.655,1.655,0,0,0,3.31,0V13.328A39.408,39.408,0,0,1,79.8,23.774L76.37,27.22a1.624,1.624,0,0,0-.45,1.6A1.676,1.676,0,0,0,77.093,30a1.624,1.624,0,0,0,1.6-.45l3.447-3.429A39.408,39.408,0,0,1,92.588,51.3H87.711a1.655,1.655,0,0,0,0,3.31h4.877A39.408,39.408,0,0,1,82.142,79.8M52.958,0a52.958,52.958,0,1,0,52.958,52.958A52.949,52.949,0,0,0,52.958,0m0,102.606a49.648,49.648,0,1,1,49.648-49.648,49.638,49.638,0,0,1-49.648,49.648",
    transform: "translate(-0.051)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.97d75dbd86206af2ce9281b90957a6f4.svg";
export { ForwardRef as ReactComponent };